<template>
  <v-layout class="partner-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="11" lg="9" class="py-0">
          <v-row>
            <v-col cols="12" md="6">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="!hover ? 0 : 2" class="height-100">
                  <v-card-title> Panel de partner </v-card-title>
                  <v-card-subtitle v-if="!token">
                    Debe generar su token de vendedor para empezar a conseguir
                    clientes
                  </v-card-subtitle>
                  <v-card-text>
                    <v-skeleton-loader type="sentences" v-if="!partner" />
                    <template v-else>
                      <v-btn
                        v-if="!token"
                        color="success"
                        @click="generateToken"
                        >Generar token</v-btn
                      >
                      <template v-else>
                        <div class="children-inline">
                          <v-text-field
                            :value="token.id"
                            label="Su token"
                            style="width: 180px"
                            ref="tokenId"
                            class="mr-2 my-2"
                            append-icon="mdi-content-copy"
                            hide-details
                            @click:append="copyToken"
                            outlined
                            background-color="#fafafa"
                            dense
                            readonly
                          />
                          <v-btn color="info" class="" @click="showShareModal">
                            <v-icon class="pr-2">mdi-qrcode</v-icon>
                            CÓMO COMPARTIR
                          </v-btn>
                        </div>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="card--stats height-100"
                  dark
                  :elevation="!hover ? 0 : 2"
                >
                  <v-card-title class="font-weight-regular">
                    Ganancias
                  </v-card-title>
                  <v-card-text>
                    <v-skeleton-loader type="sentences" v-if="!partner" />
                    <template v-else>
                      <div class="earnings" v-if="activeCurrencies['USD']">
                        <span class="val"
                          >US${{ partner.totalEarnings.toFixed(2) }}</span
                        >
                      </div>
                      <div class="earnings" v-if="activeCurrencies['ARS']">
                        <span class="val"
                          >AR${{ partner.totalEarningsArs.toFixed(2) }}</span
                        >
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="card--stats height-100"
                  dark
                  :elevation="!hover ? 0 : 2"
                >
                  <v-card-title class="font-weight-regular">
                    Saldo
                  </v-card-title>
                  <v-card-text>
                    <v-skeleton-loader type="sentences" v-if="!partner" />
                    <template v-else>
                      <div class="earnings" v-if="activeCurrencies['USD']">
                        <span class="val"
                          >US${{ partner.amountDue.toFixed(2) }}</span
                        >
                      </div>
                      <div class="earnings" v-if="activeCurrencies['ARS']">
                        <span class="val"
                          >AR${{ partner.amountDueArs.toFixed(2) }}</span
                        >
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8" xl="9">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="!hover ? 0 : 2">
                  <v-card-title> Tiendas </v-card-title>
                  <v-card-text>
                    <v-skeleton-loader type="sentences" v-if="!partner" />
                    <template v-else>
                      <p class="mb-0 grey--text" v-if="stores.length === 0">
                        Todavía no hay ninguna, ya llegarán!
                      </p>
                      <template v-else>
                        <v-data-table
                          dense
                          :headers="headers"
                          :items="stores"
                          class="stores-table elevation-0"
                        >
                          <template v-slot:item.name="{ item }">
                            <div class="children-inline">
                              <v-img
                                class="logo"
                                :src="
                                  item.logo
                                    ? `${uploadsPath}/${item.logo}`
                                    : `assets/img/restaurant-logo.png`
                                "
                              ></v-img>
                              <span class="font-weight-medium">{{
                                item.name
                              }}</span>
                              <v-btn
                                icon
                                x-small
                                :href="`https://${domain}/${item.stringId}`"
                                target="_blank"
                                ><v-icon>mdi-link-variant</v-icon></v-btn
                              >
                            </div>
                          </template>
                          <template v-slot:item.createdAt="{ item }">
                            <timeago
                              :datetime="item.createdAt"
                              :auto-update="60"
                            ></timeago>
                          </template>
                          <template v-slot:item.plan="{ item }">
                            <v-chip
                              v-if="isPlanExpired(item.planExpiresAt)"
                              label
                              small
                              color="red"
                              text-color="white"
                              >Vencido</v-chip
                            >
                            <v-chip
                              v-else-if="getEffectiveTier(item) === 0"
                              label
                              small
                              color="green"
                              text-color="white"
                              >Lite</v-chip
                            >
                            <v-chip
                              v-else-if="getEffectiveTier(item) === 1"
                              label
                              small
                              color="orange"
                              text-color="white"
                              >Plus</v-chip
                            >
                            <v-chip
                              v-else
                              label
                              small
                              color="#ff6f00"
                              text-color="white"
                              >Pro</v-chip
                            >
                          </template>
                          <template v-slot:item.planExpiresAt="{ item }">
                            <span
                              v-if="!item.planExpiresAt"
                              >Nunca</span
                            >
                            <span v-else-if="isPlanExpired(item.planExpiresAt)"
                              >Vencido</span
                            >
                            <timeago
                              v-else
                              :datetime="item.planExpiresAt"
                              :auto-update="60"
                              :converter-options="{ addSuffix: false }"
                            ></timeago>
                          </template>
                          <template v-slot:item.lastPayment="{ item }">
                            <span v-if="item.payments.length === 0">Nunca</span>
                            <timeago
                              v-else
                              :datetime="
                                item.payments[0].updatedAt ||
                                item.payments[0].createdAt
                              "
                              :auto-update="60"
                            ></timeago>
                          </template>
                        </v-data-table>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="4" xl="3" class="py-0">
              <v-row>
                <v-col cols="12" sm="6" md="12">
                  <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="!hover ? 0 : 2">
                      <v-card-title class="justify-space-between">
                        Pagos
                        <v-btn icon @click="showPaymentSettingsModal"
                          ><v-icon>settings</v-icon></v-btn
                        >
                      </v-card-title>
                      <v-card-text>
                        <v-skeleton-loader type="sentences" v-if="!partner" />
                        <template v-else>
                          <p class="grey--text pre-line">
                            Podrá solicitar el pago de su saldo cuando supere
                            los siguientes montos: Para saldo en USD:
                            <b>$5.00</b> Para saldo en ARS: <b>$500.00</b>
                          </p>
                          <span
                            class="font-size-8e mt-2"
                            style="display: block; color: #c7c7c7"
                            >Debe haber recibido ganancias de al menos 2
                            tiendas. Esta regla no aplica si su propia cuenta
                            posee una tienda con un plan pago.</span
                          >
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-col cols="12" sm="6" md="12">
                  <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="!hover ? 0 : 2">
                      <v-card-title> Reparto </v-card-title>
                      <v-card-subtitle>
                        Los tiempos son por tienda
                      </v-card-subtitle>
                      <v-card-text>
                        <v-skeleton-loader type="sentences" v-if="!partner" />
                        <template v-else>
                          <v-row>
                            <v-col
                              class="share py-0"
                              cols="4"
                              v-if="partner.shareA !== partner.shareB"
                            >
                              <span class="name">1er mes</span>
                              <h3 class="val">{{ partner.shareA }}%</h3>
                            </v-col>
                            <v-col class="share py-0" cols="4">
                              <span class="name">1er año</span>
                              <h3 class="val">{{ partner.shareB }}%</h3>
                            </v-col>
                            <v-col class="share py-0" cols="4">
                              <span class="name">después</span>
                              <h3 class="val">{{ partner.shareC }}%</h3>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { IPartner } from '../../interfaces/IPartner';
  import PartnersService from '../../api/services/partners.service';
  import { IUser } from '../../interfaces/IUser';
  import { delay } from '../../utils';
  import InputModal from '../modals/InputModal.vue';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import PartnerShareModal from './PartnerShareModal.vue';
  import PartnerPaymentSettingsModal from './PartnerPaymentSettingsModal.vue';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { Globals } from '../../modules/Globals';
  import { getTopLevelDomain } from '@/utils/domain.utils';
  import { getEffectiveTier, isPlanExpired } from '@/utils/billing-entitlements.utils';

  @Component
  export default class PartnerDashboard extends Vue {
    $refs: {
      tokenId: any;
    };
    @Prop() user: IUser;
    partnersService = new PartnersService();
    partner: IPartner = null;
    stores: IRestaurant[] = [];
    headers = [
      { text: 'Nombre', value: 'name' },
      { text: 'Creación', value: 'createdAt' },
      { text: 'Plan', value: 'plan' },
      { text: 'Tiempo restante', value: 'planExpiresAt' },
      { text: 'Último pago', value: 'lastPayment' },
    ];
    uploadsPath = Globals.uploadsPath;
    domain = getTopLevelDomain();
    getEffectiveTier = getEffectiveTier;
    isPlanExpired = isPlanExpired;

    async created() {
      this.partner = await this.partnersService.getByUser(this.user.id);
      await this.loadStores();
    }

    async loadStores() {
      this.stores = await this.partnersService.getStores(this.partner.id);
    }

    get activeCurrencies() {
      return {
        ARS: this.partner.totalEarningsArs > 0,
        USD: true,
      };
    }

    get token() {
      if (!this.partner || this.partner.tokens.length == 0) return null;
      else return this.partner.tokens[0];
    }

    copyToken() {
      try {
        const input = this.$refs.tokenId.$el.querySelector('input');
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        vueData.addAlert('Texto copiado al portapapeles', AlertType.Success);
      } catch (e) {
        console.error(e);
        vueData.addAlert('No se pudo copiar', AlertType.Error);
      }
    }

    async generateToken() {
      this.$modal.show(
        InputModal,
        {
          title: 'Ingrese token deseado',
          message:
            'El token es el código que lo identificará, pudiendo aparecer en los links que comparta y en ocasiones ingresado manualmente por el cliente',
          hint:
            'Ingrese un token fácil de recordar, use solo mayúsculas o números y sin espacios, por ejemplo PEPITO20',
          placeholder: 'Escriba un token',
          rules: [
            (v) =>
              /^[A-ZÑ0-9]{6,12}$/.test(v) ||
              'Entre 6 y 12 caractéres, solo mayúsculas o números, por ejemplo PEPITO20',
          ],
        },
        {
          name: 'token',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 600,
          clickToClose: false,
        },
        {
          submit: async (input: string) => {
            try {
              const token = await this.partnersService.createToken(input);
              this.partner.tokens.push(token);
            } catch (e) {
              console.error(e);
              vueData.serverError(e);
            }
            this.$modal.hide('token');
          },
        }
      );
    }

    showShareModal() {
      this.$modal.show(
        PartnerShareModal,
        {
          token: this.token,
        },
        {
          name: 'token',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 700,
        }
      );
    }

    showPaymentSettingsModal() {
      this.$modal.show(
        PartnerPaymentSettingsModal,
        {
          partner: this.partner,
        },
        {
          name: 'token',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 700,
        },
        {
          saved: (partner) => {
            this.partner.paypalAccount = partner.paypalAccount;
            this.partner.mpaAccount = partner.mpaAccount;
            vueData.addAlert(
              'Configuración guardada con éxito',
              AlertType.Success
            );
          },
        }
      );
    }
  }
</script>
